import { call } from "redux-saga/effects";

export default function* redirectToFallback(fallback) {
  let url = fallback;
  if (!(url.startsWith("http://") || url.startsWith("https://"))) {
    url = "http://" + url;
  }
  yield call([window.location, "assign"], url);
}
